import { render, staticRenderFns } from "./detailShow.vue?vue&type=template&id=6ce52ff0&scoped=true"
import script from "./detailShow.vue?vue&type=script&lang=js"
export * from "./detailShow.vue?vue&type=script&lang=js"
import style0 from "./detailShow.vue?vue&type=style&index=0&id=6ce52ff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce52ff0",
  null
  
)

export default component.exports